// extracted by mini-css-extract-plugin
export default {"fuelInfo":"qGSoJ","branded":"mtdt0","noFuel":"Yod8R","fuelText":"YPuy1"};